"use client";
import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { Card as C } from "../card/card.js";
import { Alert as h } from "../alert/alert.js";
import { Icon as d } from "../icon/icon.js";
import { useState as f, useId as v } from "react";
import { Text as x } from "../text/text.js";
import { Button as k } from "../../primitives/button/button.js";
import { e as T, f as g } from "../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import '../../assets/copy-to-clipboard.css';const e = {
  "copy-to-clipboard": "_copy-to-clipboard_1kpz5_1",
  "copy-to-clipboard__card": "_copy-to-clipboard__card_1kpz5_7",
  "copy-to-clipboard__content": "_copy-to-clipboard__content_1kpz5_11",
  "copy-to-clipboard__children": "_copy-to-clipboard__children_1kpz5_17"
}, O = ({ children: s }) => {
  const [y, r] = f("idle"), c = v(), _ = c + "button";
  let a = /* @__PURE__ */ o(d, { icon: T }), i = "solid", t = "Copy to clipboard", l = !1;
  switch (y) {
    case "copied":
      t = "Copied", a = /* @__PURE__ */ o(d, { icon: g }), i = "outline";
      break;
    case "error":
      l = !0;
      break;
    case "copy again":
      t = "Copy to clipboard again", i = "outline";
      break;
  }
  const m = () => {
    var p;
    const b = (p = document.getElementById(c)) == null ? void 0 : p.innerText;
    navigator.clipboard.writeText(b || "").then(
      () => {
        r("copied"), setTimeout(() => {
          r("copy again");
        }, 4e3);
      },
      (u) => {
        r("error"), console.error("Could not copy text: ", u);
      }
    );
  };
  return /* @__PURE__ */ n("div", { className: e["copy-to-clipboard"], children: [
    l && /* @__PURE__ */ o(h, { variant: "error", children: /* @__PURE__ */ o(x, { "aria-live": "polite", "aria-atomic": "true", as: "p", size: "T200", children: "Oops! We couldn't copy the text automatically. Please select the text and copy it manually using Ctrl+C (Windows) or Command+C (Mac)." }) }),
    /* @__PURE__ */ o("div", { className: e["copy-to-clipboard__card"], children: /* @__PURE__ */ o(C, { id: c, border: !0, children: /* @__PURE__ */ n("div", { className: e["copy-to-clipboard__content"], children: [
      /* @__PURE__ */ o("div", { className: e["copy-to-clipboard__children"], children: s }),
      /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
        k,
        {
          id: _,
          "aria-live": "polite",
          "aria-label": t,
          title: t,
          variant: "secondary",
          decoration: i,
          iconOnly: !0,
          icon: a,
          onClick: () => m()
        }
      ) })
    ] }) }) })
  ] });
};
export {
  O as CopyToClipboard
};
